/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiTransactionSummaryByAccount
 */
export interface InternalApiTransactionSummaryByAccount {
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionSummaryByAccount
     */
    account: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionSummaryByAccount
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiTransactionSummaryByAccount
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiTransactionSummaryByAccount
     */
    firstTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiTransactionSummaryByAccount
     */
    lastTime?: Date;
}

/**
 * Check if a given object implements the InternalApiTransactionSummaryByAccount interface.
 */
export function instanceOfInternalApiTransactionSummaryByAccount(value: object): value is InternalApiTransactionSummaryByAccount {
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function InternalApiTransactionSummaryByAccountFromJSON(json: any): InternalApiTransactionSummaryByAccount {
    return InternalApiTransactionSummaryByAccountFromJSONTyped(json, false);
}

export function InternalApiTransactionSummaryByAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionSummaryByAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'],
        'name': json['name'],
        'totalAmount': json['totalAmount'],
        'firstTime': json['firstTime'] == null ? undefined : (new Date(json['firstTime'])),
        'lastTime': json['lastTime'] == null ? undefined : (new Date(json['lastTime'])),
    };
}

export function InternalApiTransactionSummaryByAccountToJSON(json: any): InternalApiTransactionSummaryByAccount {
    return InternalApiTransactionSummaryByAccountToJSONTyped(json, false);
}

export function InternalApiTransactionSummaryByAccountToJSONTyped(value?: InternalApiTransactionSummaryByAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'name': value['name'],
        'totalAmount': value['totalAmount'],
        'firstTime': value['firstTime'] == null ? value['firstTime'] : value['firstTime'].toISOString().substring(0,10),
        'lastTime': value['lastTime'] == null ? value['lastTime'] : value['lastTime'].toISOString().substring(0,10),
    };
}

